// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 5px;
  padding: 5px;
  display: block;
}

ion-radio {
  --color: #050b05;
  --border-color: #050b05;
  --border-color-checked: #050b05;
  --background-checked: #050b05;
  --color-checked: #050b05;
}
ion-radio.radio-checked::part(mark) {
  transform: scale3d(1.1, 1.1, 1);
}

.price {
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 128%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  text-align: right;
  margin-inline-start: 4px;
  text-align: end;
  color: var(--color-black);
}

ion-label {
  display: block;
  font-family: AppFontSemiBold !important;
  font-size: 16px !important;
  text-align: left;
  color: var(--color-black) !important;
  line-height: 128%;
  letter-spacing: 0;
  text-transform: uppercase;
}

.measurement {
  font-size: 12px;
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

ion-item {
  border-radius: 2px;
  margin-top: 10px;
  border: 0.5px solid #c0c0bf;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1019607843);
}

.selected {
  font-family: AppFont, sans-serif;
}

.pfand {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-single/article-option-group-single.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACD;;AAEA;EACC,gBAAA;EAEA,uBAAA;EACA,+BAAA;EACA,6BAAA;EACA,wBAAA;AAAD;AAEC;EACC,+BAAA;AAAF;;AAIA;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,iBAAA;EAEA,wBAAA;EACA,eAAA;EACA,yBAAA;AAHD;;AAMA;EACC,cAAA;EACA,uCAAA;EACA,0BAAA;EACA,gBAAA;EACA,oCAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;AAHD;;AAKA;EACC,eAAA;AAFD;;AAIA;EACC,+BAAA;EACA,YAAA;EACA,WAAA;AADD;;AAIA;EACC,qBAAA;AADD;;AAGA;EACC,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,uDAAA;AAAD;;AAEA;EACC,gCAAA;AACD;;AAEA;EACC,eAAA;AACD","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tborder-radius: 5px;\n\tpadding: 5px;\n\tdisplay: block;\n}\n\nion-radio {\n\t--color: #050b05;\n\n\t--border-color: #050b05;\n\t--border-color-checked: #050b05;\n\t--background-checked: #050b05;\n\t--color-checked: #050b05;\n\n\t&.radio-checked::part(mark) {\n\t\ttransform: scale3d(1.1, 1.1, 1);\n\t}\n}\n\n.price {\n\tfont-family: AppFontSemiBold;\n\tfont-size: 16px;\n\tline-height: 128%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\n\ttext-align: right;\n\n\tmargin-inline-start: 4px;\n\ttext-align: end;\n\tcolor: var(--color-black);\n}\n\nion-label {\n\tdisplay: block;\n\tfont-family: AppFontSemiBold !important;\n\tfont-size: 16px !important;\n\ttext-align: left;\n\tcolor: var(--color-black) !important;\n\tline-height: 128%;\n\tletter-spacing: 0;\n\ttext-transform: uppercase;\n}\n.measurement {\n\tfont-size: 12px;\n}\nion-icon {\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\nion-item {\n\tborder-radius: 2px;\n\tmargin-top: 10px;\n\tborder: 0.5px solid #c0c0bf;\n\tbox-shadow: 0px 2px 8px 0px #0000001a;\n}\n.selected {\n\tfont-family: AppFont, sans-serif;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
